<template>
  <div class="flex flex-col items-center">
    <component
      :is="iconMappingMini[icon]"
      class="mx-auto size-6 text-gray-700 dark:text-muted-foreground"
      :class="[icon === 'special-spin' && `animate-spin`]"
    />

    <h2
      class="mt-2 text-center text-lg font-semibold text-gray-800 dark:text-foreground"
    >
      {{ title }}
    </h2>

    <div
      class="mt-1 text-center text-[0.9375rem] text-gray-600 empty:hidden dark:text-muted-foreground"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  type MappedIconMini,
  iconMappingMini,
} from "@/icons/icon-mapping-mini";

defineProps<{
  icon: MappedIconMini;
  title: string;
}>();

defineSlots<{
  default?(): unknown;
}>();
</script>
